import { Helmet } from "react-helmet-async";

export default function SEOHead({
  title = "Prajwal Halwai | Freelance Web Developer and Software Developer",
  description = "I build web applications, SaaS platforms, e-commerce platforms, and MVPs for founders and businesses worldwide. Fast to market, built to scale.",
  ogTitle,
  ogDescription,
  image = "https://assets.auxodev.dk/assets/e9ef03c8-8c42-4b2d-9ac4-e97d895bc078/profile.webp",
  canonical
}) {
  const finalTitle = title;
  const finalDesc = description;
  const finalOgTitle = ogTitle || title;
  const finalOgDesc = ogDescription || description;

  return (
    <Helmet>
      <html lang="en" />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDesc} />
      <meta name="twitter:image" content={image} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
